import { useState } from 'react';
import VoteCard from './voteCard';
import Timer from '../features/timer';
let votes = require('../seeders/seedVotes.json');


function getCardInfo(){
    const PORT=3000
    const MONGO_URI="mongodb://localhost:27017/votes"
 }
 function generateVotes(){
   let vote_map = votes.map((vote,index) => {
      return (<VoteCard vote={vote} key={index} />)
   })
   return vote_map   
}


 function MeetingContent(props) {
    const [newMSG , setNewMSG] = useState()
    const now = new Date()
    let feed = [
        {
        user: "ajph03nix@gmail.com",
        timestamp: now.toISOString(),
        body:'first line of message test text.',  
        sent: false
        },
        {
        user: "ajph03nix@gmail.com",
        timestamp: now.toISOString(),
        body:'Second line of message test text. Not quite the first',  
        sent: false
        },
        {
        user: "ajphnx@gmail.com",
        timestamp: now.toISOString(),
        body:'Third line of message test text.',  
        sent: false
        },
    ]

     class MSG_OBJ {
        constructor(props){
            // super(props)
            this.state = { 
                user:JSON.parse(localStorage.getItem('cur_user')),
                timestamp: Date.now(),
                body:'',  
                sent: false 
             } 
             handleChange = handleChange.bind(this)
             submitText = submitText.bind(this)  
            }
            
        }
    function submitText(e){
        e.preventDefault()
        // e.target.value
        
        setNewMSG(true)
    }
    function handleChange(e){
        setNewMSG(false)
        let msg_obj
        e.preventDefault()
        if (newMSG){
            let msg_obj = new MSG_OBJ
        }else{ msg_obj = e.target.value}
        
    }
     
    function openContent(evt, contentType) {
        // Declare all variables
        var i, tabcontent, tablinks;
      
        // Get all elements with class="tabcontent" and hide them
        tabcontent = document.getElementsByClassName("content-box");
        for (i = 0; i < tabcontent.length; i++) {
          tabcontent[i].style.display = "none";
        }
        // Get all elements with class="tablinks" and remove the class "active"
        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        // Show the current tab, and add an "active" class to the button that opened the tab
        // document.getElementById(contentType).style.display = "block";
        // evt.currentTarget.className += " active";

        contentType.forEach((type)=>{
            document.getElementById(type).style.display = "block";
        })
        evt.currentTarget.className += " active";
    }
    function msgFeed(){
        
        let feed_map = feed.map((msg,index) => {
            return (
             <span className='msg_wrap'> <span className='msg_nm'>{msg.user}: </span><span className='msg_tstamp'>({msg.timestamp}) - </span><span className='msg_body'> &nbsp;{msg.body} </span></span>)
            })
            console.log('feed_map',feed_map)
            return feed_map   
    }

     return (

        <div className='meeting-content'>
             <h1 className="color-grad-blue-text">{props.view} Content</h1>

                <div class="tab " id="content-tab-container">
                    <button className="tablinks color-grad-blue-text" onClick={(e)=>{openContent(e, ['content-video-wrap'])}}>video</button>
                    <button className="tablinks color-grad-blue-text" onClick={(e)=>{openContent(e, ['content-image-wrap'])}}>images</button>
                    <button className="tablinks color-grad-blue-text" onClick={(e)=>{openContent(e, ['content-audio-wrap'])}}>audio</button>
                    <button className="tablinks color-grad-blue-text" onClick={(e)=>{openContent(e, ['content-docs-wrap'])}} value="docs">docs</button>
                    <button className="tablinks color-grad-blue-text active" onClick={(e)=>{openContent(e, ['content-video-wrap','content-image-wrap','content-audio-wrap','content-docs-wrap'])}} value="all">all</button>
                </div>
            <div className="event-content-body">
             <div  className='event-content-container'>
                {/* videos: */}
                    <div className="content-box" id='content-video-wrap'>
                        <img src ="./images/film-solid.svg" alt ="video-icon"/>
                        <img src ="./images/film-solid.svg" alt ="video-icon"/>
                        <img src ="./images/film-solid.svg" alt ="video-icon"/>
                        <img src ="./images/film-solid.svg" alt ="video-icon"/>
                        <img src ="./images/film-solid.svg" alt ="video-icon"/>
                        <img src ="./images/film-solid.svg" alt ="video-icon"/>
                        <img src ="./images/film-solid.svg" alt ="video-icon"/>
                        <img src ="./images/film-solid.svg" alt ="video-icon"/>
                        <img src ="./images/film-solid.svg" alt ="video-icon"/>
                    </div>
                <br/>
                {/* images: */}
                    <div className="content-box" id='content-image-wrap'>
                        <img src ="./images/image-solid.svg" alt ="image-icon"/>
                        <img src ="./images/image-solid.svg" alt ="image-icon"/>
                        <img src ="./images/image-solid.svg" alt ="image-icon"/>
                        <img src ="./images/image-solid.svg" alt ="image-icon"/>
                        <img src ="./images/image-solid.svg" alt ="image-icon"/>
                        <img src ="./images/image-solid.svg" alt ="image-icon"/>
                        <img src ="./images/image-solid.svg" alt ="image-icon"/>
                        <img src ="./images/image-solid.svg" alt ="image-icon"/>
                        <img src ="./images/image-solid.svg" alt ="image-icon"/>
                    </div>
                <br/>
                {/* audio: */}
                    <div className="content-box" id='content-audio-wrap'>
                        <img src ="./images/headphones-solid.svg" alt ="headphones-icon"/>
                        <img src ="./images/headphones-solid.svg" alt ="headphones-icon"/>
                        <img src ="./images/headphones-solid.svg" alt ="headphones-icon"/>
                        <img src ="./images/headphones-solid.svg" alt ="headphones-icon"/>
                        <img src ="./images/headphones-solid.svg" alt ="headphones-icon"/>
                        <img src ="./images/headphones-solid.svg" alt ="headphones-icon"/>
                        <img src ="./images/headphones-solid.svg" alt ="headphones-icon"/>
                        <img src ="./images/headphones-solid.svg" alt ="headphones-icon"/>
                        <img src ="./images/headphones-solid.svg" alt ="headphones-icon"/>
                    </div>
                <br />
                <div className="content-box" id='content-docs-wrap'>
                {/* <h3>docs:</h3>
                &nbsp;
                <br></br> */}
                <div>
                    <img src ="./images/document_icon_wht.svg" alt ="document-icon"/>
                    <img src ="./images/document_icon_wht.svg" alt ="document-icon"/>
                    <img src ="./images/document_icon_wht.svg" alt ="document-icon"/>
                    <img src ="./images/document_icon_wht.svg" alt ="document-icon"/>
                    <img src ="./images/document_icon_wht.svg" alt ="document-icon"/>
                    <img src ="./images/document_icon_wht.svg" alt ="document-icon"/>
                    <img src ="./images/document_icon_wht.svg" alt ="document-icon"/>
                    <img src ="./images/document_icon_wht.svg" alt ="document-icon"/>
                    <img src ="./images/document_icon_wht.svg" alt ="document-icon"/>
                </div>

                    </div>
                <br />
                </div>
             </div>
        </div>
        
  );
}
export default MeetingContent; 